import { NgModule } from '@angular/core';
import { ContractAPIService } from './contracts-api.service';
import { TenantAPIService } from './tenant-api.service';
import { SampleAPIService } from './sample-api.service';
import { ApplicationAPIService } from './application-api.service';
import { UserAPIService } from './user-api.service';
import { AddressAPIService } from './address-api.service';
import { RequestAPIService } from './request-api.service';
import { DictionaryAPIService } from './dictionary-api.service';
import { MenuAPIService } from './menu-api.service';
import { InvoiceAPIService } from './invoice-api.service';
import { PaymentAPIService } from './payment-api.service';
import { PartnerAPIService } from './partner-api.service';
import { LanguageAPIService } from './language-api.service';
import { DocumentExportAPIService } from './documentExport-api.service';
import { NotificationAPIService } from './notification-api.service';
import { UploadAPIService } from './upload-api.service';
import { AgentSyncLogsAPIService } from './agentSyncLogs-api.service';
import { FileStoreAPIService } from './file-store-api.service';
import { EmailAPIService } from './email-api.service';
import { SettingsAPIService } from './settings-api.service';
import { CookieAPIService } from './cookie-api.service';
import { FrequentlyAskedQuestionsAPIService } from './faq-api.service';
import { SpecialOfferAPIService } from './specialOffer-api.service';
import { InsuranceAPIService } from './insurance-api.service';
import { AssetAPIService } from './asset-api.service';

@NgModule({
  providers: [
    UserAPIService,
    SampleAPIService,
    TenantAPIService,
    ApplicationAPIService,
    ContractAPIService,
    AddressAPIService,
    RequestAPIService,
    DictionaryAPIService,
    MenuAPIService,
    InvoiceAPIService,
    PaymentAPIService,
    PartnerAPIService,
    DocumentExportAPIService,
    NotificationAPIService,
    LanguageAPIService,
    UploadAPIService,
    AgentSyncLogsAPIService,
    FileStoreAPIService,
    EmailAPIService,
    SettingsAPIService,
    CookieAPIService,
    FrequentlyAskedQuestionsAPIService,
    InsuranceAPIService,
    SpecialOfferAPIService,
    AssetAPIService,
  ],
})
export class ApiServicesModule {}
